import styled from 'styled-components';

export const HowToUse: React.FC<React.PropsWithChildren<{closeModal: () => void}>> = ({closeModal}) => {
    return (
        <Group15Root>
            <Rectangle13>
                <Group>
                    <Frame2>
                        <Xicon
                            onClick={closeModal}
                            src={
                                'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/4ab3ac88-e687-4cb8-b43b-9066d20b0b6f.svg?alt=media&token=173840b0-18c9-4174-a200-47e434e3e281'
                            }
                        />
                    </Frame2>
                    <WelcomeHeresHowToGetTheMostOfRendition>
                        Welcome! Here’s how to get the most of Rendition
                    </WelcomeHeresHowToGetTheMostOfRendition>
                </Group>
                <Group2>
                    <Small>
                        <Tip1>
                            <Group5>
                                <Text1>1</Text1>
                                <Ellipse1
                                    src={
                                        'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/4b533b12-0138-40df-a404-58292601f22f.svg?alt=media&token=877546b1-c49e-43ac-9313-166a3b75b585'
                                    }
                                />
                            </Group5>
                            <Frame6>
                                <StartSmall>Start Small!</StartSmall>
                                <GenerateASmallComponentBeforeTacklingAFullScreen100LinesOfCodeIsMuchMoreFunThan1000LinesOfCode1>
                                    Generate a small component before tackling a full screen.
                                    <GenerateASmallComponentBeforeTacklingAFullScreen100LinesOfCodeIsMuchMoreFunThan1000LinesOfCode>
                                        <br />
                                        <br />
                                        100 lines of code is much more fun than 1000 lines of code.
                                    </GenerateASmallComponentBeforeTacklingAFullScreen100LinesOfCodeIsMuchMoreFunThan1000LinesOfCode>
                                </GenerateASmallComponentBeforeTacklingAFullScreen100LinesOfCodeIsMuchMoreFunThan1000LinesOfCode1>
                            </Frame6>
                        </Tip1>
                        <HomePage>
                            <SideBar>Side Bar</SideBar>
                            <Background>
                                <Content>Content</Content>
                                <TextLines>
                                    <Group14>
                                        <Group16>
                                            <Line10
                                                src={
                                                    'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/a3674377-1f45-42d5-be9c-be300bee4ddb.svg?alt=media&token=4baa871c-af61-4020-b260-d7cebaa8d851'
                                                }
                                            />
                                        </Group16>
                                        <Picture />
                                    </Group14>
                                    <Line15
                                        src={
                                            'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/4f0ffd85-a5a6-4507-ab13-0ba3c59e30ff.svg?alt=media&token=4e038ebf-5c64-4dc0-a83e-b3b12d0c695d'
                                        }
                                    />
                                </TextLines>
                            </Background>
                            <Rectangle6>
                                <Group1>
                                    <Rectangle1 />
                                    <Rectangle2 />
                                    <Rectangle3 />
                                    <Rectangle4 />
                                    <Rectangle5 />
                                </Group1>
                                <Header>
                                    <Home>Home</Home>
                                    <Home>About us</Home>
                                </Header>
                            </Rectangle6>
                        </HomePage>
                    </Small>
                    <Group13>
                        <Line16
                            src={
                                'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/e14e7e66-8678-43d7-9d91-ea20b08f0367.svg?alt=media&token=a0596edc-cdda-44f2-a319-43530e926ed9'
                            }
                        />
                        <Groups>
                            <Tip2>
                                <Group5>
                                    <Text2>2</Text2>
                                    <Ellipse1
                                        src={
                                            'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/14551cd0-5742-4958-b1dd-dbc36b9c8277.svg?alt=media&token=97fe9005-9bf6-468b-bd1f-0bf54ef37ae4'
                                        }
                                    />
                                </Group5>
                                <Frame5>
                                    <GroupsInFigmaDefineCodeStructure>
                                        Groups in Figma <br />
                                        define code structure
                                    </GroupsInFigmaDefineCodeStructure>
                                    <OnlyChildrenOfTheCurrentlySelectedNodeInFigmaWillBeCompiledIntoCode>
                                        Only children of the currently selected node in Figma will be compiled into
                                        code.
                                    </OnlyChildrenOfTheCurrentlySelectedNodeInFigmaWillBeCompiledIntoCode>
                                </Frame5>
                            </Tip2>
                            <Structure>
                                <Frame1Root
                                    src={
                                        'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/ee25565f-6b3f-4670-a64b-d7fc930b8426.svg?alt=media&token=bb55bd7c-86b4-4541-b8ed-235b68e9a36c'
                                    }
                                />
                            </Structure>
                        </Groups>
                        <Names>
                            <Tip3>
                                <Group5>
                                    <Text2>3</Text2>
                                    <Ellipse1
                                        src={
                                            'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/09b85dfb-d402-4010-8c7c-4277ca9f9187.svg?alt=media&token=adeebaac-336e-454c-a2f2-43458514ee36'
                                        }
                                    />
                                </Group5>
                                <Frame7>
                                    <NameInFigmaBecomeNamesInCode>
                                        Name in Figma <br />
                                        become names in code
                                    </NameInFigmaBecomeNamesInCode>
                                    <ItsGoodToNameThingsInFigmaAsYouWouldInCode>
                                        It’s good to name things in figma as you would in code.
                                    </ItsGoodToNameThingsInFigmaAsYouWouldInCode>
                                </Frame7>
                            </Tip3>
                            <Frame1
                                src={
                                    'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/ad542b9c-e26b-4e8b-b972-6f8a6d467548.svg?alt=media&token=86c64d3b-b773-425e-9586-a2287739da83'
                                }
                            />
                        </Names>
                    </Group13>
                </Group2>
                <GotIt onClick={closeModal}>Got it!</GotIt>
            </Rectangle13>
            <Line17
                src={
                    'https://firebasestorage.googleapis.com/v0/b/rendition-prod.appspot.com/o/74a8d15e-df47-4542-875f-9555141672d7.svg?alt=media&token=e4c2302a-d527-4326-a6f7-500dc67eccdc'
                }
            />
        </Group15Root>
    );
};

const Frame1Root = styled.img`
    width: 118px;
    height: 160px;
`;

const Group15Root = styled.div`
    position: fixed;
    z-index: 10;
    width: 100vw;
    top: 0%;
    left: 0%;
    display: flex;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    background-opacity: 0.5;
    align-items: center;
    justify-content: center;
`;

const Rectangle13 = styled.div`
    border: 3px;
    background-color: #323232;
    height: 521px;
    top: 0;
    left: 0;
    display: flex;
    opacity: 1;
    flex-direction: column;
    padding-top: 16px;
    padding-bottom: 18px;
    padding-left: 14px;
    padding-right: 48px;
    border-radius: 20px;
    border-color: #646464;
    border-style: solid;
`;

const Group = styled.div`
    height: 49px;
    margin-bottom: 29px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 89px;
    align-items: flex-start;
`;
const Frame2 = styled.div`
    cursor: pointer;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
const Xicon = styled.img`
    width: 28px;
    height: 28px;
`;
const WelcomeHeresHowToGetTheMostOfRendition = styled.div`
    color: #ffffff;
    font-size: 29px;
    font-family: Poppins;
    font-weight: 700;
    align-self: flex-end;
`;
const Group2 = styled.div`
    margin-bottom: 41px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 8px;
`;
const Small = styled.div`
    height: 356px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;
const Tip1 = styled.div`
    width: 197px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
`;
const Text1 = styled.div`
    color: #f2f2f2;
    font-size: 10px;
    font-family: Poppins;
    font-weight: 700;
    position: absolute;
    top: 3px;
    left: 8px;
`;
const Frame6 = styled.div`
    height: 106px;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
`;
const StartSmall = styled.div`
    color: #f2f2f2;
    font-size: 14px;
    font-family: Poppins;
    font-weight: 700;
`;
const GenerateASmallComponentBeforeTacklingAFullScreen100LinesOfCodeIsMuchMoreFunThan1000LinesOfCode1 = styled.div`
    color: #f2f2f2;
    width: 167px;
    font-size: 10px;
    font-family: Poppins;
    font-weight: 700;
    align-self: stretch;
`;
const GenerateASmallComponentBeforeTacklingAFullScreen100LinesOfCodeIsMuchMoreFunThan1000LinesOfCode = styled.div`
    font-size: 10px;
    color: #f2f2f2;
    font-family: Poppins;
    font-weight: 400;
    display: contents;
`;
const HomePage = styled.div`
    background-color: #1f1f1f;
    width: 293px;
    height: 227px;
    overflow: hidden;
    align-self: stretch;
    position: relative;
`;
const SideBar = styled.div`
    color: #ffffff;
    font-size: 10px;
    font-family: Pacifico;
    font-weight: 400;
    background-color: #44d7f7;
    width: 39px;
    height: 129px;
    position: absolute;
    top: 65px;
    left: 21px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0px;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
`;
const Background = styled.div`
    background-color: #0dd877;
    width: 132px;
    height: 129px;
    position: absolute;
    top: 65px;
    left: 96px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 7px;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left: 11px;
    padding-right: 33px;
    align-items: flex-start;
    border-radius: 10px;
`;
const Content = styled.div`
    color: #ffffff;
    font-size: 10px;
    font-family: Pacifico;
    font-weight: 400;
`;
const TextLines = styled.div`
    height: 98px;
    align-self: flex-end;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
const Group14 = styled.div`
    margin-bottom: 28px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
const Group16 = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 7px;
    padding-top: 1px;
    padding-bottom: 1px;
`;
const Line10 = styled.img`
    width: 64px;
    height: 1px;
`;
const Picture = styled.div`
    background-color: #f2f629;
    width: 46px;
    height: 43px;
    border-radius: 6px;
`;
const Line15 = styled.img`
    width: 116px;
    height: 1px;
`;
const Rectangle6 = styled.div`
    background-color: rgba(34, 34, 34, 0.5400000214576721);
    width: 293px;
    height: 227px;
    position: absolute;
    top: 0;
    left: 0;
`;
const Group1 = styled.div`
    width: 273.36px;
    height: 49px;
    position: absolute;
    top: 12px;
    left: 10px;
`;
const Rectangle1 = styled.div`
    border-width: 1px;
    border-color: #ffffff;
    border-style: solid;
    width: 267px;
    height: 43px;
    position: absolute;
    top: 2px;
    left: 2px;
`;
const Rectangle2 = styled.div`
    background-color: #ffffff;
    border-width: 1px;
    border-color: #ffffff;
    border-style: solid;
    width: 3.44px;
    height: 4.13px;
    position: absolute;
    top: 0;
    left: 267.92px;
`;
const Rectangle3 = styled.div`
    background-color: #ffffff;
    border-width: 1px;
    border-color: #ffffff;
    border-style: solid;
    width: 3.44px;
    height: 4.13px;
    position: absolute;
    top: 42.88px;
    left: 267.92px;
`;
const Rectangle4 = styled.div`
    background-color: #ffffff;
    border-width: 1px;
    border-color: #ffffff;
    border-style: solid;
    width: 3.44px;
    height: 4.13px;
    position: absolute;
    top: 0;
    left: 0;
`;
const Rectangle5 = styled.div`
    background-color: #ffffff;
    border-width: 1px;
    border-color: #ffffff;
    border-style: solid;
    width: 3.44px;
    height: 4.13px;
    position: absolute;
    top: 42.88px;
    left: 0;
`;
const Header = styled.div`
    background-color: #f44a4a;
    width: 225px;
    position: absolute;
    top: 19px;
    left: 21px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 8px;
    padding-left: 13px;
    padding-right: 13px;
    padding-top: 9px;
    padding-bottom: 9px;
    border-radius: 10px;
`;
const Group13 = styled.div`
    width: 609px;
    height: 356px;
    position: relative;
`;
const Line16 = styled.img`
    width: 397px;
    height: 1px;
    position: absolute;
    top: 0;
    left: 0;
`;
const Groups = styled.div`
    height: 304px;
    position: absolute;
    top: 0;
    left: 56px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;
const Tip2 = styled.div`
    width: 197px;
    align-self: stretch;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
`;
const Frame5 = styled.div`
    height: 97px;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
const GroupsInFigmaDefineCodeStructure = styled.div`
    color: #f2f2f2;
    width: 167px;
    font-size: 14px;
    font-family: Poppins;
    font-weight: 700;
`;
const OnlyChildrenOfTheCurrentlySelectedNodeInFigmaWillBeCompiledIntoCode = styled.div`
    color: #f2f2f2;
    width: 167px;
    font-size: 10px;
    font-family: Poppins;
    font-weight: 700;
`;
const Structure = styled.div`
    width: 118px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
`;

const Names = styled.div`
    height: 299px;
    position: absolute;
    top: 0;
    left: 354px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
`;
const Tip3 = styled.div`
    width: 204px;
    margin-left: 11px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
`;
const Frame7 = styled.div`
    height: 82px;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
`;
const NameInFigmaBecomeNamesInCode = styled.div`
    color: #f2f2f2;
    width: 174px;
    font-size: 14px;
    font-family: Poppins;
    font-weight: 700;
    align-self: stretch;
`;
const ItsGoodToNameThingsInFigmaAsYouWouldInCode = styled.div`
    color: #f2f2f2;
    width: 167px;
    font-size: 10px;
    font-family: Poppins;
    font-weight: 400;
`;
const Frame1 = styled.img`
    width: 255px;
    height: 156px;
    align-self: stretch;
`;
const GotIt = styled.div`
    cursor: pointer;
    color: #ffffff;
    font-size: 14px;
    font-family: Poppins;
    font-weight: 600;
    line-height: 40px;
    background-color: #0dd877;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.25);
    width: 119px;
    height: 40px;
    margin-right: 393px;
    align-self: flex-end;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius: 12px;
`;
const Line17 = styled.img`
    width: 397px;
    height: 1px;
    position: absolute;
    top: 94px;
    left: 652px;
`;
const Group5 = styled.div`
    width: 20px;
    height: 20px;
    position: relative;
`;
const Ellipse1 = styled.img`
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    left: 0;
`;
const Home = styled.div`
    color: #ffffff;
    font-size: 10px;
    font-family: Pacifico;
    text-decoration: underline;
    font-weight: 400;
`;
const Text2 = styled.div`
    color: #f2f2f2;
    text-align: center;
    font-size: 10px;
    font-family: Poppins;
    font-weight: 700;
    position: absolute;
    top: 3px;
    left: 7px;
`;
